import React from 'react';

export default function PrivacyPageFr() {
  return (
    <div style={{
      maxWidth: 900,
      margin: '0 auto',
      padding: '40px 20px',
      lineHeight: 1.6,
      color: '#1b1b1f'
    }}>
      <h1 style={{ marginBottom: 24, color: '#006b44' }}>Politique de confidentialité de Radiomonitor.net</h1>
      <p>
        Cette politique décrit quelles données collecte Radiomonitor.net, comment elles sont utilisées et comment nous protégeons vos
        informations. En utilisant notre Service, vous acceptez cette Politique.
      </p>

      <h2 style={{ marginTop: 32, marginBottom: 16 }}>1. Données que nous collectons</h2>
      <p>Nous collectons uniquement les données nécessaires au fonctionnement du Service :</p>
      <ul style={{ paddingLeft: 20 }}>
        <li>informations techniques (adresse IP, type d'appareil, navigateur, système d'exploitation) ;</li>
        <li>données statistiques sur les connexions des auditeurs aux radios en ligne ;</li>
        <li>données de contact fournies lors de l'inscription (par exemple e-mail).</li>
      </ul>
      <p>
        Nous ne collectons pas de données sensibles (p. ex. passeport ou données bancaires) sauf si l'utilisateur les fournit pour un paiement ou une communication.
      </p>

      <h2 style={{ marginTop: 32, marginBottom: 16 }}>2. Utilisation des données</h2>
      <p>Les données sont utilisées uniquement pour :</p>
      <ul style={{ paddingLeft: 20 }}>
        <li>fournir des services d'analytique et de monitoring ;</li>
        <li>améliorer le Service ;</li>
        <li>assurer l'assistance technique ;</li>
        <li>informer des mises à jour et nouvelles fonctionnalités.</li>
      </ul>

      <h2 style={{ marginTop: 32, marginBottom: 16 }}>3. Transmission à des tiers</h2>
      <p>Nous ne vendons ni ne transmettons vos données à des tiers.</p>
      <p>Exception faite lorsque la loi l'exige.</p>
      <p>
        Pour les paiements, nous pouvons utiliser des systèmes tiers fiables qui traitent les données indépendamment de nous.
      </p>

      <h2 style={{ marginTop: 32, marginBottom: 16 }}>4. Conservation des données</h2>
      <p>Nous conservons les données uniquement pendant la période nécessaire à la prestation des services.</p>
      <p>L'utilisateur peut demander la suppression de ses données ; nous y répondrons dans un délai raisonnable.</p>

      <h2 style={{ marginTop: 32, marginBottom: 16 }}>5. Protection des données</h2>
      <p>
        Radiomonitor.net applique des mesures techniques et organisationnelles pour protéger les données contre l'accès non autorisé, la modification ou la destruction.
      </p>
      <p>
        Nous ne pouvons pas garantir une sécurité Internet absolue, mais nous faisons tout notre possible pour la maintenir.
      </p>

      <h2 style={{ marginTop: 32, marginBottom: 16 }}>6. Cookies</h2>
      <p>Nous pouvons utiliser des cookies pour faciliter l'utilisation et collecter des statistiques.</p>
      <p>Vous pouvez désactiver les cookies dans votre navigateur, mais cela peut affecter le fonctionnement du Service.</p>

      <h2 style={{ marginTop: 32, marginBottom: 16 }}>7. Vos droits</h2>
      <p>L'utilisateur a le droit :</p>
      <ul style={{ paddingLeft: 20 }}>
        <li>d'obtenir les informations sur les données conservées ;</li>
        <li>d'en demander la correction ou la suppression ;</li>
        <li>de retirer son consentement au traitement.</li>
      </ul>

      <h2 style={{ marginTop: 32, marginBottom: 16 }}>8. Modifications de la Politique</h2>
      <p>Cette Politique peut être mise à jour périodiquement. La version actuelle est disponible sur Radiomonitor.net.</p>

      <h2 style={{ marginTop: 32, marginBottom: 16 }}>9. Contacts</h2>
      <p>
        Pour toute question liée à la confidentialité, contactez :
        <br />
        support@radiomonitor.net
      </p>
    </div>
  );
}
